import { isEmpty, isNil } from 'lodash';
import React, { useMemo } from 'react';

import Hljs from 'main/components/Hljs';
import Collapsible from 'pages/Bulletin/components/Collapsible';
import ProtectedData from 'pages/components/ProtectedData';
import { logger } from 'services/logger';

import useStyles from './styles';

import CopyButton from '../CopyButton';

interface Props {
    sourceData?: string;
    className?: string;
}

const Code: React.FC<Props> = ({ sourceData, className }) => {
    const { classes, cx } = useStyles();

    const code = useMemo(() => {
        switch (true) {
            case isEmpty(sourceData):
            case isNil(sourceData):
                return '';
            case sourceData?.endsWith('='):
                try {
                    return atob(sourceData);
                } catch (error) {
                    logger.warn("Can't extract Base64 source code", error);
                    return sourceData;
                }
            default:
                return sourceData;
        }
    }, [sourceData]);

    if (isEmpty(code)) {
        return null;
    }

    return (
        <div className={cx(classes.root, className)}>
            <ProtectedData data={code}>
                <div className={classes.toolbar}>
                    <CopyButton value={code} />
                </div>
                <Collapsible inverted maxSize={510}>
                    <Hljs language="bash" className={classes.code}>
                        {code}
                    </Hljs>
                </Collapsible>
            </ProtectedData>
        </div>
    );
};

export default Code;
